// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"313":"bf4b8ee8","963":"bf4b8ee8"}[chunkId] + ".chunk.css";
};